function workerCode() {
  function replaceOutcomesShortKeys(data) {
    return {
      items: data.items.map((item) => ({
        id: item.i,
        name: item.n
      }))
    };
  }
  function replaceMarketsShortKeys(data) {
    const items = data.items.map((item) => ({
      id: item.i,
      name: item.n,
      marketGroups: item.m.map((group) => ({
        id: group.i,
        sportId: group.s,
        isMain: group.m,
        name: group.n,
        order: group.o,
        isLive: group.l,
        specifier: group.sp,
        specifierValue: group.sv
      }))
    }));
    return { items };
  }
  function makeMarketGroups(data) {
    const uniqGroupSet = /* @__PURE__ */ new Set();
    data.items.forEach((market) => {
      return Object.values(market.marketGroups).filter((group) => group.name).map((group) => uniqGroupSet.add(group.name));
    });
    return { ...data, groups: Array.from(uniqGroupSet.values()) };
  }
  self.onmessage = ({ data }) => {
    const { task, payload } = data || {};
    let result;
    switch (task) {
      case "MakeMarketGroups":
        result = makeMarketGroups(replaceMarketsShortKeys(payload));
        break;
      case "FormatOutcomesDescription":
        result = replaceOutcomesShortKeys(payload);
        break;
      default:
        return;
    }
    self.postMessage(result);
  };
}
function createWorker(func) {
  const blob = new Blob([`(${func.toString()})()`], {
    type: "application/javascript"
  });
  return new Worker(URL.createObjectURL(blob));
}
function startWorker(initialData) {
  return new Promise((resolve, reject) => {
    const worker = createWorker(workerCode);
    worker.onmessage = ({ data }) => {
      resolve(data);
      worker.terminate();
    };
    worker.onerror = (error) => {
      reject(error);
      worker.terminate();
    };
    worker.postMessage(initialData);
  });
}
export {
  startWorker
};
